import type { MaybeRef } from 'vue'
import { unref } from 'vue'
import { useApps } from './useApps'

export function useApp(appId?: MaybeRef<number | undefined>) {
  const { data: apps } = useApps({ enabled: !!unref(appId) })

  return computed(() =>
    apps.value?.items?.find(app => app.id === unref(appId)),
  )
}
